/******* 
 *  @description:   输入 => Q1 
 */
export const QUESTION_TYPE_TEMP_CHECK = 'temp_check'

/******* 
 *  @description:   输入 => Q1 
 */
export const QUESTION_TYPE_ANSWER = 'answer'

/******* 
 *  @description:   输入 => Q1 
 */
export const QUESTION_TYPE_INPUT = 'input'

/******* 
 *  @description:   输入 => Q1 
 */
export const QUESTION_TYPE_TEXT = 'text'

/******* 
 *  @description:   多选 => Q1A1 
 */
export const QUESTION_TYPE_CHECKBOX = 'checkbox'

/******* 
 *  @description:   单选 => Q1A1 
 */
export const QUESTION_TYPE_RADIO = 'radio'

/******* 
 *  @description:   量表(一排的radio选择指定) => Q1 
 */
export const QUESTION_TYPE_RATING_SCALE = 'rating_scale'

/******* 
 *  @description:   评分题(选项后面有分值) => Q1A1 
 */
export const QUESTION_TYPE_RATING = 'rating'

/******* 
 *  @description:   时间题 
 */
export const QUESTION_TYPE_DATE = 'date'

/******* 
 *  @description:   矢量题 
 */
export const QUESTION_TYPE_MATRIX = 'matrix_checkbox'

/******* 
 *  @description:   组合题 
 */
export const QUESTION_TYPE_COMBINATION = 'combination'

/******* 
 *  @description:   疾病下拉 
 */
export const QUESTION_TYPE_DISEASE = 'disease'

/******* 
 *  @description:   药品下拉 
 */
export const QUESTION_TYPE_MEDICINE = 'medicine'

/******* 
 *  @description:   组合题 
 */
export const QUESTION_TYPE_GROUP = 'group'

/******* 
 *  @description:   附件上传 
 */
export const QUESTION_TYPE_UPLOAD = 'upload'
